module.exports = __webpack_public_path__ + "static/img/title_3_blue@2x.879b86e2.png";